import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { TABLE_NAME as tableName } from "../../../helpers";
import { BaseLiveLoadAutocomplete } from "../BaseLiveLoadingAutocomplete";
import { useLiveLoadAutocomplete } from "../../../customHook/useLiveLoadAutocomplete";



const createLiveLoadAutocompleteColumnFilter = ({ key, getLabel }) =>
  ({ value, header, handleFilterSet, multiple = true }) => {
    const { t } = useTranslation();
    const [selectedOption, setSelectedOption] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [initialResponse, setInitialResponse] = useState(null);
    
    const {
      options,
      handleLoadPage,
      handleSearchOptions,
      handleResetFilter,
      stableGetLabel
    } = useLiveLoadAutocomplete(key, getLabel);
  
    useEffect(() => {
      setIsLoading(options.isLoading);
      
      if (options.data.length > 0) {
        setInitialResponse(options);
      }
    }, [options?.isLoading, options?.data.length, options?.onPage]);

    return (
      <BaseLiveLoadAutocomplete
        value={value}
        header={header}
        multiple={multiple}
        initialResponse={initialResponse}
        isLoading={isLoading}
        getOptionLabel={stableGetLabel}
        getOptionValue={stableGetLabel}
        placeholder={`${t("auto_complete_place_holder")} ${
          tableName[header.toLowerCase()] || ""
        }`}
        handleFilterSet={handleFilterSet}
        selectedOption={selectedOption}
        onSelectOption={setSelectedOption}
        onLoadPage={handleLoadPage}
        onSearchOptions={handleSearchOptions}
        resetFilter={handleResetFilter}
      />
    );
  };

const createLiveLoadAutocompleteColumnEditor = ({ key, getLabel }) =>
  ({ value, header, onBlur, setIsEditing }) => {
    const {
      options,
      handleLoadPage,
      handleSearchOptions,
      handleResetFilter,
      stableGetLabel
    } = useLiveLoadAutocomplete(key, getLabel);

    return (
      <BaseLiveLoadAutocomplete
        value={value}
        header={header}
        onBlur={onBlur}
        initialResponse={options}
        isLoading={false}
        setIsEditing={setIsEditing}
        getOptionLabel={stableGetLabel}
        getOptionValue={stableGetLabel}
        isEditing
        onLoadPage={handleLoadPage}
        onSearchOptions={handleSearchOptions}
        resetFilter={handleResetFilter}
      />
    );
  };

export {
  createLiveLoadAutocompleteColumnFilter,
  createLiveLoadAutocompleteColumnEditor,
  useLiveLoadAutocomplete,
};